import {
  FETCH_SUMMARY_BEHAVIOUR_INIT,
  FETCH_SUMMARY_BEHAVIOUR_SUCCESS,
  FETCH_SUMMARY_BEHAVIOUR_FAILURE,
  RESET_SUMMARY_BEHAVIOUR,
  SET_FILTER_SUMMARY_BEHAVIOUR
} from './types';
import API from './api';

/* Actions Creators */

export function setFilterSummaryBehaviour(obj, loadingField = null) {
  return {
    type: SET_FILTER_SUMMARY_BEHAVIOUR,
    payload: {
      filter:obj,
      loadingField: loadingField
    }
  };
}

export function resetSummaryBehaviour() {
  return {
    type: RESET_SUMMARY_BEHAVIOUR
  };
}

/* Data Main */
function fetchApiSuccess(data) {
  return {
    type: FETCH_SUMMARY_BEHAVIOUR_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  return {
    type: FETCH_SUMMARY_BEHAVIOUR_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_SUMMARY_BEHAVIOUR_INIT
  };
}

export function fetchSummaryBehaviourApi(obj) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

export function downloadSummaryReport(filter) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadSummaryReport(filter);
    } catch (error) {}
  };
}

export function downloadNoProcessReport(filter) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadNoProcessReport(filter);
    } catch (error) {}
  };
}




// WEBPACK FOOTER //
// ./source/client/actions/summary_behaviour/index.js